export const STANDARD_LOCATION_SHIFT_REQUIRED_KEY = "COMMON_LOCATION.STD_LOCATION_ONLY_WITH_SHIFT";

const normalizeId = (value) => {
    const parsed = value != null && value !== "" ? Number(value) : null;
    return parsed != null && !Number.isNaN(parsed) ? parsed : null;
};

export const isAdditionalAssignmentAtStandardLocation = (stdOrtId, tatortId) => {
    const normalizedStdOrtId = normalizeId(stdOrtId);
    const normalizedTatortId = normalizeId(tatortId);

    return normalizedStdOrtId != null && normalizedStdOrtId === normalizedTatortId;
};

export const isStandardLocationShiftMissing = ({ hasKissSign, stdOrtId, tatortId, shiftId }) =>
    Boolean(
        hasKissSign &&
            isAdditionalAssignmentAtStandardLocation(stdOrtId, tatortId) &&
            normalizeId(shiftId) == null
    );

export const shouldShowShiftSelectForAdditionalLocation = ({
    hasKissSign,
    hasSelectableShifts,
    stdOrtId,
    tatortId,
}) => Boolean(hasKissSign && (hasSelectableShifts || isAdditionalAssignmentAtStandardLocation(stdOrtId, tatortId)));
